import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=b6d8f30a&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=b6d8f30a&prod&scoped=true&lang=css"
import style1 from "./Registration.vue?vue&type=style&index=1&id=b6d8f30a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d8f30a",
  null
  
)

export default component.exports